import * as React from 'react';

import TileStandardHeaderAvatar from './avatar/TileStandardHeaderAvatar';
import TileStandardHeaderDetails from './details/TileStandardHeaderDetails';
import TileStandardHeaderChevron from './chevron/TileStandardHeaderChevron';

import './tile-standard-header.scss';

import type { TileStandardSize } from 'types';

type Props = {
  onResize: (a: TileStandardSize) => void
};

const TileStandardHeader = (
  {
    onResize
  }: Props
): JSX.Element => (
  <div className="tile-standard-header">
    <div className="tile-standard-header__avatar">
      <TileStandardHeaderAvatar />
    </div>
    <TileStandardHeaderDetails />
    <TileStandardHeaderChevron
      onResize={onResize}
    />
  </div>
);

export default TileStandardHeader;
